export default "__VITE_ASSET__DmHK6UHf__"